/**
 * Emails que veem Campanhas mesmo sem profile admin
 * (mesmo recorte de empresa Certtus/Clickey no menu).
 */
const mEmailsCampanhasLiberadas = ["itamar@certtus.com.br", "diogo@certtus.com.br"]

/**
 * @param {string|null|undefined} cEmail
 * @returns {boolean}
 */
export function usuarioCampanhasEmailLiberado(cEmail) {
  if (!cEmail) return false
  return mEmailsCampanhasLiberadas.includes(String(cEmail).trim().toLowerCase())
}
